import { SelectSize } from '@99designs/common/components/Select';
import { getComponentClasses } from '@99designs/common/utils/app';
import React from 'react';

interface Category {
    key: string;
    title: string;
    children?: Category[];
}

interface Props {
    value: string;
    onChange: (value: string) => void;
    categories: Category[];
    size: SelectSize;
    placeholder?: string;
}

const CategorySelect: React.SFC<Props> = ({
    categories,
    onChange,
    size,
    placeholder,
    ...props
}) => {
    const classes = getComponentClasses('select', [size]);

    return (
        <div className={classes}>
            <select {...props} onChange={({ target: { value } }) => onChange(value)}>
                {placeholder && (
                    <option value="" disabled={true}>
                        {placeholder}
                    </option>
                )}

                {categories.map(parent => (
                    <optgroup label={parent.title} key={parent.key}>
                        {parent.children &&
                            parent.children.map(child => (
                                <option key={child.key} value={child.key}>
                                    {child.title}
                                </option>
                            ))}
                    </optgroup>
                ))}
            </select>
        </div>
    );
};

export default CategorySelect;
